import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import RefreshIcon from '@mui/icons-material/Refresh';
import { Box, CircularProgress } from '@mui/material';
import { green, red } from '@mui/material/colors';
import { t } from 'i18next';
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import HtmlTooltip from '@sophocles/components/HtmlTooltip';
import { fetchUnProcessedRmasForRadio } from '@sophocles/entities/Rma';

class ConflictingRMAChecker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      rmas: null,
    };
  }

  componentDidMount() {
    if (this.props.radio) {
      this.fetch(this.props.radio, this.props.ignoreRMA);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.radio !== nextProps.radio) {
      this.fetch(nextProps.radio, nextProps.ignoreRMA);
    }
  }

  fetch = (radio, ignoreRMA) => {
    const { fetchRmas, onFetch } = this.props;

    // send out a false to start the fetch
    if (typeof onFetch === 'function') {
      onFetch(false);
    }

    this.setState({ loading: true, rmas: null });
    fetchRmas(radio).then(res => {
      // remove ignored RMA entries
      if (ignoreRMA) {
        res = res.filterNot(rma => rma.get('id', -1) == ignoreRMA);
      }
      // pass out whether or not it is empty
      if (typeof onFetch === 'function') {
        onFetch(res.isEmpty());
      }
      // save rmas to state.
      this.setState({ rmas: res, loading: false });
    });
  };

  render() {
    const { loading, rmas } = this.state;
    const { radio } = this.props;

    const goodIcon = <CheckIcon title={t('rma.good', 'Good')} sx={{ fill: green[500] }} />;
    const badIcon = <CloseIcon title={t('rma.bad', 'Bad')} sx={{ fill: red[500] }} />;
    const loadingIcon = <CircularProgress size="small" />;
    const refreshIcon = (
      <RefreshIcon title={t('rma.refresh', 'Refresh')} sx={{ cursor: 'pointer' }} onClick={() => this.fetch(radio)} />
    );

    const icon = loading ? loadingIcon : rmas == null ? null : rmas.isEmpty() ? goodIcon : badIcon;

    const popover = (
      <HtmlTooltip
        title={
          <div style={{ padding: '8px', width: '100%' }}>
            <h5 style={{ borderBottom: '1px solid #666', textAlign: 'center', paddingBottom: '4px' }}>
              {t('rma.rmaCheckerLegend', 'RMA Checker Legend')}
            </h5>
            <div style={{ fontSize: '14px' }}>
              <div style={{ display: 'flex', paddingBottom: '4px' }}>
                <CheckIcon
                  title={t('rma.good', 'Good')}
                  sx={{ fill: green[500], flex: '0 0 30px', padding: '0 6px' }}
                />{' '}
                <span>{t('rma.rmaCheckerGoodDesc', 'Good: This radio is not in an issued or quickshipped RMA.')}</span>
              </div>
              <div style={{ display: 'flex', paddingBottom: '4px' }}>
                <CloseIcon title={t('rma.bad', 'Bad')} sx={{ fill: red[500], flex: '0 0 30px', padding: '0 6px' }} />{' '}
                <span>
                  {t(
                    'rma.rmaCheckerBadDesc',
                    'Bad: This radio is active in one or more RMA. You must cancel or complete those RMAs to be allowed to use this radio on a new RMA.',
                  )}
                </span>
              </div>
              <div style={{ display: 'flex', paddingBottom: '4px' }}>
                <RefreshIcon title={t('rma.refresh', 'Refresh')} sx={{ flex: '0 0 30px', padding: '0 6px' }} />{' '}
                <span>
                  {t(
                    'rma.rmaCheckerRefreshDesc',
                    'Refresh: Click this to refresh the related RMAs. This helps after you cancel them out in another tab.',
                  )}{' '}
                </span>
              </div>
              <div style={{ display: 'flex', paddingBottom: '4px' }}>
                <CircularProgress
                  title={t('rma.loading', 'Loading')}
                  size={14}
                  sx={{ flex: '0 0 30px', padding: '0 6px' }}
                />{' '}
                <span>
                  {t('rma.rmaCheckerLoadingDesc', 'Loading: Just loading your results, give it a few seconds. ')}
                </span>
              </div>
            </div>
          </div>
        }
      >
        <InfoOutlinedIcon fontSize="small" sx={{ fill: '#666' }} />
      </HtmlTooltip>
    );

    return (
      <div style={{ fontSize: '14px' }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <span>{t('rma.rmaCheckerColon', 'RMA Checker:')} </span> {icon} {rmas && !rmas.isEmpty() && refreshIcon}{' '}
          {popover}
        </Box>
        {rmas && !rmas.isEmpty() && (
          <div>
            <ul>
              {rmas.map(rma => (
                <li key={rma.get('id')}>
                  <Link to={`/rma/${rma.get('id')}/view`} target="_blank">
                    {t('rma.rmaNumberHash', 'RMA #{{num}}', { num: rma.get('rma_number', t('rma.noneLower', 'none')) })}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    fetchRmas: radio => dispatch(fetchUnProcessedRmasForRadio(radio)),
  };
}

const ConflictingRMACheckerContainer = connect(mapStateToProps, mapDispatchToProps)(ConflictingRMAChecker);

export default ConflictingRMACheckerContainer;
